import React, { useMemo, useCallback } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { JumpingTeamsColumns } from '../events/jumping/Columns';
import NotAvailable from 'components/common/NotAvailable';
import { isStartListStatus, isFinishedStatus, isLiveStatus } from 'helpers/status';
import CaptionTable from 'components/general/table/CaptionTable';
import Status from 'components/presentation/Status';
import { JumpPreviousCurrent } from '../events/jumping/JumpPreviousCurrent';
import JumpSpecifications from '../events/jumping/JumpSpecifications';
import TableExpanded from '../events/jumping/TableExpandedTeams';
import LoaderSubComponent from 'components/general/LoaderSubComponent';
import ProgressionRule from 'components/common/ProgressionRule';
import { isJumpingTeamQual } from '../helper/EquHelpers';


function EquJumpingTeam({ data }) {

  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()

  const { breakPoint } = useViewport();
  const isMobile = breakPoint === "sm" || breakPoint === "xs" 

  const resultStatus = data?.results?.status?.code;
  const scheduleStatus = data?.results?.schedule?.status?.code;

  const isStartList = isStartListStatus(resultStatus);
  const isFinished = isFinishedStatus(resultStatus);
  const isLive = isLiveStatus(resultStatus)

  const tableColumns = useMemo(() => JumpingTeamsColumns(), []);

  const renderRowSubComponent = useCallback(({ row }) => {
    let componentExpanded = <TableExpanded row={row?.original} isStartList={isStartList}/>
    return (
      <LoaderSubComponent component={componentExpanded} />
    )
    // eslint-disable-next-line
  }, [resultStatus]);

 
  if (!data?.results?.items) return <NotAvailable />;

  const currentId = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'CURRENT')?.ei_value;
  const current = data?.results?.items?.find(i => i?.teamAthletes?.find(ta => ta?.athlete?.code === currentId));
  const currentTeamId =current?.participant?.code;

  const previousId = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'LAST_COMP')?.ei_value;
  const previous = data?.results?.items?.find(i => i?.teamAthletes?.find(ta => ta?.athlete?.code === previousId));
  const previousTeamId =current?.participant?.code;

  const teamAfter = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'TEAM_AFTER')?.ei_value; 

  const fences = data?.config?.extendedConfig?.filter(ec => ec?.extension?.find(e => e?.code === 'EFFORT'))?.sort((a,b) => a?.pos - b?.pos);

  const efforts = fences?.map(f => {
        const effort = f.extension?.find(e => e?.code === 'EFFORT');
        return ({
          pos: effort?.pos,
          value: effort?.value,
          pos2: f?.pos
        });
  });

  const getHiddenColumns = () => {
    const finishedHidden = isFinished ? ['StartOrder'] : [];
    const startListHidden = isStartList ? ['Rank', 'TotalPenalties', 'Time','QualMark'] : [];
    const mobileHidden = isMobile ? [] : [];
    const mobileLiveHidden = isMobile && isLive ? ['StartOrder'] : []
    const qualMarkHidden = isJumpingTeamQual(mirs_rsc) ? [] : ['QualMark'];
    return [...finishedHidden, ...startListHidden, ...mobileHidden, ...qualMarkHidden, ...mobileLiveHidden];
  }

  const getCurrentIndicator = (row) => {
    const isCurrent =  row.original.participant.code === currentTeamId;
    let out = {className: isCurrent ? 'currentIndicator' : ''}
    return out  
  }

  const getInitialSortBy = () => {
    return isStartList ? [{ id: 'StartOrder', desc: false }] : [{ id: 'Rank', desc: false }];
  }

  const caption = (
    <CaptionTable
      leftCol={<span className="fw-bold"><Label data={isStartList ? 'HeaderStartList': 'HeaderResults'} /></span>}
      rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />}
     />
  );
  
  const filtersQualRule = {
    type: ['QUALIFICATION'],
    code: ['QUAL_RULE']
  };

  return (
    <>
        { isLive && <JumpPreviousCurrent current={current} currentId={currentId} previous={previous} previousId={previousId} efforts={efforts} settings={{"visible":8, "step":8}} type='T' teamAfter={teamAfter}/> }
        <ProgressionRule key="progress-component" data={data?.config} filter={filtersQualRule} itemData={'value'} />   
        <MirsTable
          id={`mirs-table-results-${mirs_rsc}`}
          caption={caption}
          data={data?.results?.items}
          columns={tableColumns}
          keyRow={"participant-code"}
          initialSortBy={getInitialSortBy()}
          hiddenColumns={getHiddenColumns()}
          renderRowSubComponent={renderRowSubComponent}
          getRowProps={row => { return getCurrentIndicator(row) }}
        />
        <JumpSpecifications data={data} />
    </>
  );
}

export default EquJumpingTeam;



